import { useContext, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useQuery, useMutation } from "@apollo/client"

// Context
import { UserContext } from "../../context/userContext"
import axios from "axios"
import cloudFunctionsEndpoint from "../../config/cloudFunctionsEndpoint"

// Component
import FormProfile from "./Form/FormProfile"
import { LoaderMedium } from "../../components/Loaders"
import ROUTES from "../../components/Routes/routesContants"

// Queries
import { GET_USER, EDIT_PROFILE } from "./queries"

//Prime

export default function EditProfile() {
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()
  const msgs1 = useRef(null)

  const mutationVariables = {
    staff_id: userCtx.session.user.staff_id,
  }

  const { data, loading } = useQuery(GET_USER, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
    },
    context: {
      headers: {
        // "user": JSON.stringify(user)
      },
    },
    skip: !userCtx.session.user.staff_id,
    fetchPolicy: "network-only",
  })

  const [editUser] = useMutation(EDIT_PROFILE, {
    variables: mutationVariables,
    refetchQueries: [
      {
        query: GET_USER,
        variables: { staff_id: userCtx.session.user.staff_id },
      },
    ],
    onCompleted: () => {
      navigate(ROUTES.EDIT_PROFILE)
      const postBody = {
        sessionId: userCtx.session.user.staff_id,
      }
      const endpoint = cloudFunctionsEndpoint()
      axios.post(`${endpoint}/clearSession`, postBody)
      msgs1.current.show([
        {
          detail: "You profile changes have been saved!",
          sticky: false,
        },
      ])
    },
    onError: (err) =>
      msgs1.current.show([
        {
          severity: "error",
          detail: err.message,
          sticky: false,
        },
      ]),
  })

  if (loading) return <LoaderMedium />

  return (
    <div>
      <h1>Edit Profile</h1>
      <FormProfile
        fields={data.user}
        onSubmitHandler={editUser}
        messageRef={msgs1}
      />
    </div>
  )
}
